module.exports = __webpack_public_path__ + "img/right_arrow.2bd6ab05.svg";